import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../store/auth-context";

const RequireLogin = ({ children, redirectPath }) => {
  const authContext = useContext(AuthContext);
  const location = useLocation();
  const targetPath = redirectPath || `${location.pathname}${location.search}`;

  if (authContext.isLoading) {
    return <div>Loading...</div>;
  }

  if (!authContext.isLoggedIn) {
    return (
      <Navigate to="/" replace state={{ redirectAfterLogin: targetPath }} />
    );
  }

  return children;
};

export default RequireLogin;
